<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-3 pt-md-5">
      <div class="container-fluid">
          <div class="header-body">
              <div class="row align-items-center pt-4">
                  <div class="col-lg-6 col-7">
                    
                  </div>
              </div>
          </div>
      </div>
    </base-header>
    
    <div class="container px-0 mx-0">
      <div class="row">
        <div class="col-md-3">
          <div class="card">
            <div class="card-header">
              <base-button  type="primary" size="sm" class=" float-right" @click="modals.modal0 = true">Thêm</base-button>
              <modal :show.sync="modals.modal0">
                <template>
                  <card type="secondary" shadow
                    header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5"
                    class="border-0">
                    <div class="text-center text-muted mb-4">
                        Thông tin thiết bị
                    </div>
                    <form role="form">
                      <base-input alternative
                        class="mb-3"
                        placeholder="Tên thiết bị"
                        v-model="newdevice.name"
                        >
                      </base-input>
                      <base-input alternative
                        class="mb-3"
                        placeholder="Loại thiết bị"
                        v-model="newdevice.vmodel"
                        >
                      </base-input>
                      <base-input alternative
                        class="mb-3"
                        placeholder="Tọa độ"
                        v-model="newdevice.location"
                        >
                      </base-input>
                      <div class="text-center">
                        <base-button type="primary" class="my-4" @click="addDevice">Lưu</base-button>
                      </div>
                    </form>
                
                  </card>
                </template>
                
              </modal>
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="device in listDevices" :key="device._id" @click="selectDevice(device)" v-bind:class="{ active: device._id==selectedDevice._id}">{{device.name}}  |  {{device.location}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <div class="card-header">
            Tên Thiết Bị: {{selectedDevice.name}}
            <br>
            Loại: {{selectedDevice.vmodel}}
            <br>
            Tọa Độ: {{ selectedDevice.location }}
            <base-dropdown class="float-right" position="right">
              <base-button slot="title-container" type="secondary" class="dropdown-toggle">
                Regular
              </base-button>              
              <a class="dropdown-item" @click="modals.modal1 = true">Thêm Card</a>
              <a class="dropdown-item" @click="modals.modal2 = true">Thêm Port</a>
              <a class="dropdown-item" @click="deleteDevice">Xóa Thiết Bị</a>
            </base-dropdown>
            </div>
            <div class="card-body">
              <table class="table">
              <thead>
              
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Label</th>
                  <th>Ext Device</th>
                  <th>Ext Card</th>
                  <th>Ext Port</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>

                <tr v-for="(port, index) in listports" :key="port._id">
                  <td class="py-1" width="5%">{{index}}</td>
                  <td class="py-1">{{ port.name }}</td>
                  <td class="py-1">{{ port.type }}</td>
                  <td class="py-1">{{ port.label}}</td>
                  <td class="py-1">{{ port.ext.device_name }}</td>
                  <td class="py-1">{{ port.ext.card_name }}</td>
                  <td class="py-1">{{ port.ext.port_name }}</td>
                  <td class="py-1 px-1" width="5%">
                    <div v-if="!port.ext.device_name">
                    <base-button type="info" size="sm" @click="connectPort(port)">kết nối</base-button>
                    </div>
                    <div v-else>
                    <base-button type="Default" size="sm" @click="disconnectPort(port._id)">ngắt</base-button>
                    </div>
                  </td>
                  <td class="py-1 px-1" width="5%">
                    <base-button type="warning" size="sm" @click="deletePort(port)">xóa</base-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr class="my-0">
            <template v-for="card in listcards">
              <div class="container" :key="card._id">
                <div class="row">
                  <div class="col-4">
                    
                    <h5>
                    Card: {{card.name}}
                    
                    <br>
                    Type: {{card.cardtype}}               
                    
                    </h5>
                  </div>
                  <div class="col">
                    <div class="float-right">
                      <base-button type="danger" size="sm" class="my-2" @click="deleteCard(card._id)">Xóa</base-button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <table class="table">
                  <thead>              
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Label</th>
                      <th>Ext Device</th>
                      <th>Ext Card</th>
                      <th>Ext Port</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr v-for="(port, index) in card.ports" :key="port._id">
                      <td  width="5%" class="py-1">{{index}}</td>
                      <td class="py-1">{{ port.name }}</td>
                      <td class="py-1">{{ port.type }}</td>
                      <td class="py-1">{{ port.label}}</td>
                      <td class="py-1">{{ port.ext.device_name }}</td>
                      <td class="py-1">{{ port.ext.card_name }}</td>
                      <td class="py-1">{{ port.ext.port_name }}</td>
                      <td class="py-1 px-1" width="5%">
                        <div v-if="!port.ext.device_name">
                        <base-button type="info" size="sm" @click="connectPort(port)">kết nối</base-button>
                        </div>
                        <div v-else>
                        <base-button type="Default" size="sm" @click="disconnectPort(port)">ngắt</base-button>
                        </div>
                      </td>
                      <td class="py-1 px-1" width="5%">
                        <base-button type="warning" size="sm" @click="deletePort(port)">xóa</base-button>
                      </td>
                    </tr>
                  </tbody>
                  </table>
                </div>
              </div>
            </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal :show.sync="modals.modal1">
      <template>
        <card type="secondary" shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0">
          <div class="text-center text-muted mb-4">
              Thông tin Card
          </div>
          <form role="form">
            <base-input alternative
              class="mb-3"
              placeholder="Tên Card"
              v-model="newcard.name"
              >
            </base-input>
            <base-input alternative
              class="mb-3"
              placeholder="Loại Card"
              v-model="newcard.cardtype"
              >
            </base-input>
            <div class="text-center">
              <base-button type="primary" class="my-4" @click="addCard">Lưu</base-button>
            </div>
          </form>
      
        </card>
      </template>
      
    </modal>
    <modal :show.sync="modals.modal2">
      <template>
        <card type="secondary" shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0">
          <div class="text-center text-muted mb-4">
              Mẫu
          </div>
          <form role="form">
          <div v-if="listcards.length>0">
            <base-input label="Card">
              <select class="form-control" v-model="selectcard">
                <option disabled value=""></option>
                <option v-for="card in listcards" :value="card" :key="card._id" >{{card.name}}</option>
              </select>
            </base-input>
            </div>
            <label>Số lượng</label>
            <base-input alternative
              class="mb-3"
              placeholder="Số Lượng"
              v-model.number="ports_temp.weight"
              >
            </base-input>
            <label>Bắt đầu</label>
            <base-input alternative
              class="mb-3"
              placeholder="Bắt đầu"
              v-model.number="ports_temp.begin"
              >
            </base-input>
            <label>Định dạng</label>
            <base-input alternative
              class="mb-3"
              placeholder="Định dạng"
              v-model="ports_temp.format"
              >
            </base-input>
            <base-input alternative
              label="Loại"
              class="mb-3"
              placeholder="Loại port"
              v-model="ports_temp.ptype"
              >
            </base-input>
            <div class="text-center">
              <base-button type="primary" class="my-4" @click="addPort">Thêm</base-button>
            </div>
          </form>
      
        </card>
      </template>
      
    </modal>
    <modal :show.sync="modals.modal3">
      <template>
        <card type="secondary" shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0">
          <div class="text-center text-muted mb-4">
              Kết nối
          </div>
          <form role="form">
            <base-input label="Thiết bị">
              <select class="form-control" v-model="selectextdevice">
                <option disabled value=""></option>
                <option v-for="device in listDevices" :value="device" :key="device._id" >{{device.name}}</option>
              </select>
            </base-input>
            <base-input label="Card">
              <select class="form-control" v-model="selectextcard">
                <option value=""></option>
                <option v-for="card in extcard" :value="card" :key="card._id" >{{card.name}}</option>
              </select>
            </base-input>             
            <base-input label="Port">
              <select class="form-control" v-model="selectextport">
                <option disabled value=""></option>
                <option v-for="port in extport" :value="port" :key="port._id" >{{port.name}}</option>
              </select>
            </base-input>  

            <base-input alternative
              label="Nhãn"
              class="mb-3"
              placeholder="Nhãn"
              v-model="label"
              >
            </base-input>
            <div class="text-center">
              <base-button type="primary" class="my-4" @click="connectingPort">Thêm</base-button>
            </div>
          </form>
      
        </card>
      </template>
      
    </modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listDevices: [],
      selectedDevice: {},
      listcards: [],
      selectcard:"",
      ports_temp: { weight: 1, ptype: "", begin: 0, format: "fe0/{{number}}"},
      listports: [],
      selectedport: {},
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
        modal3: false
      },
      newdevice: {
        name: "",
        vmodel: "",
        location: ""
      },
      newcard: {
        name: "",
        cardtype: "",
        device: ""
      },
      selectextdevice: "",
      selectextcard: "",
      selectextport: "",
      label: ""
    }
  },
  methods: {
    async getAllDevices() {
      let result = await this.$http.get('/network/devices')
      this.listDevices = result.data
      
    },
    async selectDevice(device){
      this.selectedDevice = device
      let result = await this.$http.get('/network/port/device', {params: {"deviceID":device._id}})
      let listports = result.data
      let temp = await this.$http.get('/network/cards', {params: {"deviceID":device._id}})
      if(temp.data) {
        this.listcards = temp.data
        for(let i=0; i<this.listcards.length;i++) 
        {
          let raw = listports.filter(port => { return port.card_id == this.listcards[i]._id})
          this.listcards[i].ports = raw
        }
      }
      this.listports = listports.filter(port => { return !port.card_id})
    },
    async addDevice(){
      if(this.newdevice.name) {
        let data = {
          device: this.newdevice
        }
        await this.$http.post('/network/device/add', data)
      }
      this.newdevice.name = ""
      this.newdevice.vmodel = ""
      this.newdevice.location = ""
      this.modals.modal0 = false
    },
    async addCard() {
      if(this.selectedDevice.name) {
        this.newcard.device = this.selectedDevice._id
        let data = {
          card: this.newcard
        }
        await this.$http.post('/network/card/add', data)
        
      }
      this.newcard.name = ""
      this.newcard.cardtype = ""
      this.newcard.device = ""
      this.modals.modal1 = false
    },
    async deleteCard(cardID){
      let data = {
        "cardID": cardID
      }
      await this.$http.post('/network/card/delete', data)
      let cards = this.listcards.filter(card => { return card._id != cardID })
      this.listcards = cards
    },
    async addPort() {
      let soluong = Number(this.ports_temp.weight)
      let begin = Number(this.ports_temp.begin)
      if( !Number(soluong).isNaN && !Number(begin).isNaN){
        
        for(let i=begin; i< begin+soluong; i++){
          let port_name = this.ports_temp.format.replace("{{number}}", i)
          let data = {
            "port": {
              "name": port_name,
              "type": this.ports_temp.ptype,
              "card_name": this.selectcard.name? this.selectcard.name:null,
              "card_id": this.selectcard._id? this.selectcard._id:null ,
              "device_name": this.selectedDevice.name ,
              "device_id":  this.selectedDevice._id
            }
          }
          await this.$http.post('/network/port/add', data)
        } 
      }
      this.ports_temp.weight = 0
      this.ports_temp.begin = ''
      this.ports_temp.ptype = null
      this.modals.modal2 = false
    },
    async deleteDevice(){
      let data = {
        "deviceID": this.selectedDevice._id
      }
      await this.$http.post('/network/device/delete', data)
      this.listDevices = this.listDevices.filter(element => { return element._id != this.selectedDevice._id})
      this.selectedDevice= {}
    },
    async deletePort(port){
      let data = {
        "port": port
      }
      await this.$http.post('/network/port/delete', data)
      if(port.card_id) {
        let card = this.listcards.filter(card => { return card._id ==port.card_id})[0]
        let listcards = this.listcards.filter(card => { return card._id != port.card_id})
        this.listcards = listcards
        let ports = card.ports.filter(element => { return element._id != port._id})
        card.ports = ports
        this.listcards.push(card)
      }
      else {
        this.listports = this.listports.filter(element => { return element._id != port._id})
      }
    },
    connectPort(port) {
      this.selectedport = port
      this.modals.modal3 = true
    },
    async connectingPort() {
      let data = {
        "sport":this.selectedport._id,
        "dport":this.selectextport._id,
        "label": this.label
      }
      await this.$http.post('/network/port/connect', data)
      this.modals.modal3 = false
      this.selectextport = ""
      this.selectedport = ""
      this.selectextdevice = ""
      this.label = ""
      await this.selectDevice(this.selectedDevice)
      
    },
    async disconnectPort(portID) {
      let data = {
        "port": portID
      }
      await this.$http.post('/network/port/disconnect', data)
      await this.selectDevice(this.selectedDevice)
    }
  },
  asyncComputed: {
    async extcard() {
      let result = await this.$http.get('/network/cards',{params: {"deviceID":this.selectextdevice._id}})
      return result.data
    },
    async extport() {
      if(this.selectextcard) {
        let result = await this.$http.get('/network/port/card', {params:{"cardID": this.selectextcard._id}})
        let ports = result.data
        ports = ports.filter(port => { return port.card_id})
        ports = ports.filter(port => { return !port.ext.device_id})
        return ports
      }
      else if(this.selectextdevice){
        let result = await this.$http.get('/network/port/device', {params:{"deviceID": this.selectextdevice._id}})
        let ports = result.data
        ports = ports.filter(port => { return !port.card_id})
        ports = ports.filter(port => { return !port.ext.device_id})
        return ports
      }
      
    }
  },
  mounted() {
    this.getAllDevices()
  },
}
</script>
<style scoped>
.maxwidth {
  max-width: 1440px !important;
}
.active {
  background: #666633;
} 
</style>